import { useCallback } from 'react'
import { useLocation, useParams } from 'react-router-dom'

import { downloadTenantShipmentAttachment } from 'repositories/ShipmentApi/downloadTenantShipmentAttachment'
import { useAttachmentBlobPreview } from 'components/AttachmentPreview/useAttachmentBlobPreview'
import loginStorage from 'utils/loginStorage'

type RouteParams = {
  shipmentId: string
  visitId: string
  attachmentId: string
}

export const useTenantAttachmentPreviewController = () => {
  const { shipmentId, visitId, attachmentId } = useParams<RouteParams>()
  const { search } = useLocation()
  const fileName = new URLSearchParams(search).get('name') ?? ''

  const session = loginStorage.getWarehouseSession()
  const tenantId = typeof session?.tenantId === 'number' ? session.tenantId : null

  const fetchBlob = useCallback(
    () =>
      downloadTenantShipmentAttachment({
        tenantId: tenantId as number,
        shipmentId: Number(shipmentId),
        visitId: Number(visitId),
        attachmentId: Number(attachmentId),
      }),
    [tenantId, shipmentId, visitId, attachmentId]
  )

  return useAttachmentBlobPreview(fileName, fetchBlob, tenantId != null)
}
